import produce from 'immer';
import { handleActions } from 'redux-actions';

const initialState = {
  sidebarCommandId: null,
  overlayCommandId: null,
};

export default handleActions(
  {
    'COMMAND/RESET': (state, action) => initialState,
    'COMMAND/RESET_ACTIVE_PANELS': (state, action) =>
      produce(state, (draft) => {
        draft.sidebarCommandId = null;
        draft.overlayCommandId = null;
      }),
    'COMMAND/TOGGLE_SIDEBAR': (state, action) =>
      produce(state, (draft) => {
        const { commandId } = action.payload;

        if (state.sidebarCommandId === commandId) {
          draft.sidebarCommandId = null;
        } else {
          draft.sidebarCommandId = commandId;
          draft.overlayCommandId = null;
        }
      }),
    'COMMAND/TOGGLE_OVERLAY': (state, action) =>
      produce(state, (draft) => {
        const { commandId } = action.payload;

        if (state.overlayCommandId === commandId) {
          draft.overlayCommandId = null;
        } else {
          draft.sidebarCommandId = null;
          draft.overlayCommandId = commandId;
        }
      }),
  },
  initialState,
);
